class ChatMessageStore {
	constructor() {
        this.messageByRoom = {};
    }
    
    storeMessage(msg) {
    	if (!msg) return;
    	let room = this.messageByRoom[msg.rid];
    	if (!room) {
    		room = {};
    		this.messageByRoom[msg.rid] = room;
    	}
    	room[msg._id] = msg;
    }

    storeMessages(messages) {
        if (!messages || !messages.length) return;
        for (let i = 0; i < messages.length; i++)
        	this.storeMessage(messages[i]);
    }

    getRoomsMessages(roomId) {
    	let msgs = this.messageByRoom[roomId];
    	if (!msgs) return {};
    	return msgs;
    }
}

export let chatMessageStore = new ChatMessageStore();